import { render, staticRenderFns } from "./InfoTextCell.vue?vue&type=template&id=2c2a0fe7&"
import script from "./InfoTextCell.vue?vue&type=script&lang=js&"
export * from "./InfoTextCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports